export function updateBasicDetails(data){
    return {
        type: "UPDATE_BASIC_DETAILS",
        payload: data
    }
}

export function fetchUserDetails(){
    return {
        type : "FETCH_USER_DETAILS",
    }
}

export function updateRights(data){
    return {
        type : "UPDATE_RIGHTS",
        payload : data 
    }
}

export function signOut(){
    return {
        type : "SIGN_OUT"
    }
}


// WEBPACK FOOTER //
// ./src/redux/action/main.js